import React from 'react';
import { connect } from 'react-redux';
import {
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnName,
  columnPublisher,
  columnCollections,
  columnStatus,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
} from '@/constants/fields';
import { sortingFilters } from '@/constants/states';
import { toggleDatasetsSelected, toggleDatasetColumnOrderBy } from '../actions';
import DatasetsTableColumnsWrapper from '../components/DatasetsTableColumnsWrapper';

const DatasetsTableColumns = ({
  category,
  items,
  onCheckBoxClick,
  onOrderByColumn,
  orderBy,
  singleSorting,
  columns = [
    columnMultiSelect,
    columnName,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnStatus,
    columnVisibility,
    columnPublisher,
    columnCollections,
    columnTools,
  ],
}) => (
  <DatasetsTableColumnsWrapper
    category={category}
    columns={columns}
    items={items}
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
    onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
    orderBy={orderBy}
    singleSorting={singleSorting}
  />
);

const mapStateToProps = ({
  datasets: { datasets },
}, { category }) => {
  const { orderBy, singleSorting } = datasets[category] || sortingFilters();
  return ({ orderBy, singleSorting });
};

const mapDispatchToProps = {
  onCheckBoxClick: toggleDatasetsSelected,
  onOrderByColumn: toggleDatasetColumnOrderBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetsTableColumns);
